import { createSelector } from 'reselect';
const selectShippingsState = createSelector((state) => state.shippings, state => state);
const selectShippingsFees = createSelector(selectShippingsState, state => state.fees);
const selectPudos = createSelector(selectShippingsState, state => state.pudos);
export { selectShippingsFees, selectPudos };
